/**
 * Custom product-card "Format" select (Single Copy / 6-Pack, etc.).
 *
 * Powers the variant dropdown rendered by snippets/product-card-custom-form.liquid.
 * Loaded globally (layout/theme.liquid) so it works for every card on the site,
 * including cards injected after load (e.g. the product-recommendations AJAX
 * fetch) -- all handlers delegate on `document`.
 */
(() => {
  if (window.__mrbCardFormSelectInit) return;
  window.__mrbCardFormSelectInit = true;

  const OPEN = '.product-card__select[open]';

  const closeAll = (except) => {
    document.querySelectorAll(OPEN).forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  };

  // Selecting an option: update the hidden variant id, the trigger label, the
  // selected state, the displayed price, then close the dropdown.
  document.addEventListener('click', (event) => {
    const option = event.target.closest('.product-card__select-option');
    if (option) {
      const select = option.closest('.product-card__select');
      const format = option.closest('.product-card__format');
      const card = option.closest('.product-card');
      const input = format && format.querySelector('input[name="id"]');
      if (input) input.value = option.dataset.value;

      const value = select && select.querySelector('.product-card__select-value');
      // data-display is the card-only shorthand ("Set" for Single-Copy Set);
      // the full title stays in data-label for the cart/panel.
      if (value) value.textContent = option.dataset.display || option.dataset.label;

      if (select) {
        select.querySelectorAll('.product-card__select-option').forEach((o) => {
          o.classList.toggle('is-selected', o === option);
          const li = o.closest('[role="option"]');
          if (li) li.setAttribute('aria-selected', o === option ? 'true' : 'false');
        });
      }

      if (card && option.dataset.price) {
        card.querySelectorAll('.product-card__price .price').forEach((el) => {
          el.textContent = option.dataset.price;
        });
      }

      // Set cards: keep the under-title set-includes line in step with the
      // chosen Copies variant (mirrors the product page's Set Includes swap).
      const includes = card && card.querySelector('[data-includes]');
      if (includes) {
        includes.textContent = option.dataset.value === includes.dataset.sixVariantId
          ? includes.dataset.sixText
          : includes.dataset.singleText;
      }

      if (select) select.removeAttribute('open');
      return;
    }

    // Click outside any open dropdown closes it.
    if (!event.target.closest('.product-card__select')) closeAll();
  });

  // Only one dropdown open at a time; Escape closes.
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (d.matches && d.matches('.product-card__select') && d.open) closeAll(d);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
